/* Styles */
import '@/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'
import 'bulma-helpers/css/bulma-helpers.min.css'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'
import { ToastProgrammatic as Toast } from 'buefy'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VueLazyload from 'vue-lazyload'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'

import './vee-validate'
/* Router & Store */
import router from './router'
import store from './store'

/* Service Worker */
import './registerServiceWorker'

/* Vue. Main component */
import App from './App.vue'

/* Vue. Component in recursion */
import AsideMenuList from '@/components/AsideMenuList'
import BaseInput from './components/BaseInput.vue'
import format from 'date-fns/format'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://1c610b202c8c4e54911aa11a3d3d1b8e@o344953.ingest.sentry.io/5528259',
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true
      }),
      new Integrations.BrowserTracing()
    ],

    tracesSampleRate: 5.0
  })
}

Vue.use(VueAnalytics, {
  id: 'UA-83410159-1',
  router
})

Vue.use(VueGtag, {
  config: { id: "G-V340VM6EP7" }
}, router)

/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  store.commit('asideMobileStateToggle', false)
})

Vue.config.productionTip = false

/* These components are used in recursion algorithm */
Vue.component('AsideMenuList', AsideMenuList)

Vue.use(Buefy, {
  defaultDateFormatter: date => format(date, 'dd/MM/yyyy')
})
Vue.use(VueLazyload)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('BaseInput', BaseInput)

let routeGuard = async (to, from, next) => {
  const authenticationRequired = to.meta && to.meta.authenticated

  if (authenticationRequired) {
    const authenticated = await store.dispatch('isAuthenticated')
    if (!authenticated) {
      return next({ name: 'Login', query: { redirect: to.path } })
    }

    if (authenticated && !store.getters.user.role.includes('admin')) {
      if (window.location.host === 'localhost:8080') {
        window.location = 'https://capturefit.com'
      }
      else {
        window.location = '/';
      }

      return next(false);
    }

    const showQuicklinks = to.meta && to.meta.quicklinks
    if (showQuicklinks) {
      if (
        !store.getters.event ||
        store.getters.event._id !== to.params.eventid
      ) {
        await store.dispatch('setEvent', to.params.eventid)
      }
    }

    const superadmin = to.meta && to.meta.superadmin
    if (superadmin) {
      if (!store.getters.user.superadmin) {
        Toast.open({
          duration: 5000,
          message: `You do not have the right permissions.`,
          position: 'is-bottom',
          type: 'is-danger'
        })
        next(false)
      }
    }
  }

  if (window.fbq) {
    window.fbq('track', 'PageView', {
      page_path: to.path
    });
  }
  next()
}

router.beforeEach(routeGuard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
